var map = {
	"./App.vue": 898,
	"./components/GamesList.vue": 8786,
	"./components/GamesList.vue.vue": 8786,
	"./components/MemoryCard.vue": 589,
	"./components/MemoryGame.vue": 66,
	"./components/PuzzleGame.vue": 2271,
	"./components/PuzzleItem.vue": 7024,
	"./components/UI/GameBtn.vue": 4141,
	"./components/WinView.vue": 1017,
	"./views/GamesView.vue": 5248,
	"./views/HomeView.vue": 9227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1895;